import { Navigate } from "react-router-dom";
import { routes } from "../helpers/constants";
import LoginPage from "../pages/Login/LoginPage";
import DMLogin from "../pages/Login/DMLogin";
import AdminLogin from "../pages/Login/AdminLogin";

import DMPortal from "../pages/DMPortal";
import DMRestaurantReport from "../pages/DMPortal/DMRestaurantReport";
import DMFTSReport from "../pages/DMPortal/DMFTSReport";
import DMAuditorReport from "../pages/DMPortal/DMAuditorReport";
import DMLabReport from "../pages/DMPortal/DMLabReport";

import AdminPortal from "../pages/AdminPortal";
import RestaurantReport from "../pages/AdminPortal/RestaurantReport";
import FTSReport from "../pages/AdminPortal/FTSReport";
import AuditorReport from "../pages/AdminPortal/AuditorReport";
import LabReport from "../pages/AdminPortal/LabReport";

export const authRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.adminLogin} /> },
  { path: routes.adminLogin, element: <AdminLogin /> },
  { path: routes.dmLogin, element: <DMLogin /> },
];

export const adminRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.adminPortal} /> },
  { path: routes.adminPortal, element: <AdminPortal /> },
  { path: routes.adminRestaurantReport, element: <RestaurantReport /> },
  { path: routes.adminFTSReport, element: <FTSReport /> },
  { path: routes.adminAuditorReport, element: <AuditorReport /> },
  { path: routes.adminLabReport, element: <LabReport /> },
];

export const dmRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.dmPortal} /> },
  { path: routes.dmPortal, element: <DMPortal /> },
  { path: routes.dmRestaurantReport, element: <DMRestaurantReport /> },
  { path: routes.dmFTSReport, element: <DMFTSReport /> },
  { path: routes.dmAuditorReport, element: <DMAuditorReport /> },
  { path: routes.dmLabReport, element: <DMLabReport /> },
];

export const invalidRoutes = [
  { path: "*", element: <AdminLogin /> },
  { path: routes.adminLogin, element: <AdminLogin /> },
];
